<template>
    <div class="loader ">
        <img src="../assets/bg/planetagirando.gif" />
    </div>    
</template>

<script>
export default {
   name : "Loader",

}
</script>

<style>
    .loader {
        left: 50%;
        top: 50%;
        position: fixed;
        width: 50px;
        height: 50px;
        z-index: 9998;
        background: rgba(255, 255, 255);
        border-radius: 25px;
    }
    .loader img{
        width: 100%;
    }
</style>